import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
// Lazy load below-fold sections to reduce initial bundle
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TruthSection = lazy(() => import('./components/TruthSection').then(m => ({
  default: m.TruthSection
})));
const ProductIntro = lazy(() => import('./components/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const ModulesSection = lazy(() => import('./components/ModulesSection').then(m => ({
  default: m.ModulesSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const UpsellSection = lazy(() => import('./components/UpsellSection').then(m => ({
  default: m.UpsellSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Divider = () => <div className="w-full max-w-4xl mx-auto px-8" data-id="element-0">
    <div className="h-px w-full bg-gradient-to-r from-transparent via-[#d4af37]/20 to-transparent" data-id="element-1" />
  </div>;
export function App() {
  return <main className="min-h-screen bg-[#0a1628] selection:bg-[#d4af37]/30 selection:text-white overflow-hidden font-sans text-[#e2e8f0]" data-id="element-2">
      {/* Global subtle background gradient */}
      <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#0f1d36] via-[#0a1628] to-[#0a1628] -z-10" data-id="element-3" />

      <HeroSection data-id="element-4" />
      <Divider data-id="element-5" />

      <Suspense fallback={null} data-id="element-6">
        <ProblemSection data-id="element-7" />

        <TruthSection data-id="element-8" />

        <ProductIntro data-id="element-9" />
        <Divider data-id="element-10" />

        <ModulesSection data-id="element-11" />
        <Divider data-id="element-12" />

        <BonusSection data-id="element-13" />
        <Divider data-id="element-14" />

        <ComparisonTable data-id="element-15" />
        <Divider data-id="element-16" />

        <TestimonialsSection data-id="element-17" />

        <UpsellSection data-id="element-18" />

        <PricingSection data-id="element-19" />
        <Divider data-id="element-20" />

        <FinalCTA data-id="element-21" />
        <Divider data-id="element-22" />

        <GuaranteeSection data-id="element-23" />
        <Divider data-id="element-24" />

        <FAQSection data-id="element-25" />
      </Suspense>
    </main>;
}